import React from "react";
import { Container } from "./Container";
import { Row } from "react-bootstrap";
export const GridPage = ({ children, fullWidth = false, type = "tiled", }) => (React.createElement("div", { className: `grid grid--${type}` },
    React.createElement(Container, { fluid: fullWidth }, children)));
export const GridRow = ({ children }) => (React.createElement(Container, { className: "grid-container" },
    React.createElement(Row, { className: "grid-row" }, children)));
